import { httpClient } from '../api/http.client';
import { User, UserFilters, UserListResponse, UserDetailResponse } from '@/domain/entities';

export class UserRepository {
  async getAll(filters: UserFilters = {}): Promise<UserListResponse> {
    const params = new URLSearchParams();

    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.offset) params.append('offset', filters.offset.toString());
    if (filters.search) params.append('search', filters.search);
    if (typeof filters.hasOrders === 'boolean') {
      params.append('hasOrders', String(filters.hasOrders));
    }

    const queryString = params.toString();

    return httpClient.get<UserListResponse>(
      `/api/admin/users${queryString ? `?${queryString}` : ''}`
    );
  }

  async getById(id: string, recentLimit?: number): Promise<UserDetailResponse> {
    const params = new URLSearchParams();
    if (recentLimit) params.append('recentLimit', recentLimit.toString());
    const queryString = params.toString();

    return httpClient.get<UserDetailResponse>(
      `/api/admin/users/${id}${queryString ? `?${queryString}` : ''}`
    );
  }

  async delete(id: string): Promise<void> {
    await httpClient.delete<void>(`/api/admin/users/${id}`);
  }
}

export const userRepository = new UserRepository();

